import { appHandler } from '@blaze-cms/core-ui';
import setRefreshToken from './set-refresh-token';
import { COOKIE_KEY, EXPIRED_COOKIE, COOKIE_EXPIRY_TIME, COOKIE_PATH } from '../constants';

const handleLogin = async (data, client, doNotClearStore = false) => {
  const app = appHandler.getApp();
  const { loginResult: { result } = {} } = data || {};
  const { accessToken } = result || {};
  if (app) {
    await app.events.emitAsync('package:core-auth-ui:login', { data });
    await app.openQueryChecker.checkOpenQueries(true);
  }
  if (!accessToken) return null;

  if (!doNotClearStore) {
    await client.clearStore();
  }
  document.cookie = EXPIRED_COOKIE;
  const now = new Date();
  const time = now.getTime();
  const expireTime = time + 1000 * COOKIE_EXPIRY_TIME;
  now.setTime(expireTime);
  const validCookie = `${COOKIE_KEY}=${accessToken};expires=${now.toUTCString()};${COOKIE_PATH}`;
  document.cookie = validCookie;
  setRefreshToken(data);

  return validCookie;
};

export default handleLogin;
